import { Entry } from '../Entry'

export function Entry20240514() {
  return (
    <Entry title="14/05/2023 - v3.7.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15861/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
